
(function(){
const mail=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const modal=document.getElementById('quiz');
const steps=[...modal.querySelectorAll('.step')];
const bar=document.getElementById('qBar');
const count=document.getElementById('qCount');
const back=document.getElementById('qBack');
const next=document.getElementById('qNext');
const skip=document.getElementById('qSkip');
const foot=document.getElementById('qFoot');
const total=8;
let i=0;
const API='https://toastique-quiz-6925deb4e16f.herokuapp.com';
const SITEKEY='6LdpYEIrAAAAAF54KTq8RP_hzaUVuZE0EBkiR525';
const qError=document.getElementById('qError');
const digits=v=>String(v||'').replace(/\D/g,'');
function radio(n){const e=document.querySelector('input[name="'+n+'"]:checked');return e?e.value:''}
function val(id){const e=document.getElementById(id);return e?e.value.trim():''}

function utm(){
const p=new URLSearchParams(window.location.search);
return {utm_source:p.get('utm_source')||'',utm_medium:p.get('utm_medium')||'',utm_campaign:p.get('utm_campaign')||'',utm_term:p.get('utm_term')||'',utm_content:p.get('utm_content')||'',gclid:p.get('gclid')||''};
}
function token(){
return new Promise(function(res){
if(typeof grecaptcha==='undefined'||!grecaptcha.execute){res('');return}
try{grecaptcha.ready(function(){grecaptcha.execute(SITEKEY,{action:'submit'}).then(res).catch(function(){res('')})})}catch(e){res('')}
});
}
async function submitQuiz(){
qError.hidden=true;
next.disabled=true;next.textContent='Submitting';
const u=utm();
const rt=await token();
const payload={data:{
Email:val('q-email'),
First_Name:val('q-first'),
Last_Name:val('q-last'),
Name:val('q-first')+' '+val('q-last'),
phone:val('q-phone'),
State:val('q-state'),
City:val('q-city'),
Primary_Goal:radio('goal'),
Funding:radio('funding'),
Credit:radio('credit'),
Net_Worth:radio('net'),
Liquid_Capital:radio('capital'),
Ownership:radio('runbusiness'),
Hospitality_Experience:radio('hospitality'),
Franchise_Experience:radio('franchise'),
Semi_Absentee_Full_Time:'',
Employee_Management:radio('manage'),
Timeline:radio('time'),
Zip_Codes:val('q-zip'),
utm_source:u.utm_source,utm_medium:u.utm_medium,utm_campaign:u.utm_campaign,
utm_term:u.utm_term,utm_content:u.utm_content,gclid:u.gclid,
Confident_Being_Face_of_Toastique:radio('confident'),
Passion_About_Healthy_Food_and_Lifestyle:radio('healthy'),
Semi_Absentee_Willing_to_Work_Full_Time_for_a_Year:'',
SMS_Opt_In:document.getElementById('q-sms').checked,
recaptcha_token:rt
}};
try{
const r=await fetch(API+'/submit-form',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
const j=await r.json().catch(function(){return {}});
if(!r.ok){
let msg=j.error||('Submission failed ('+r.status+')');
const codes=(j.details&&j.details['error-codes'])||[];
if(codes.length)msg+=' ['+codes.join(', ')+']';
if(/recaptcha/i.test(msg)&&location.hostname!=='toastique.com'&&location.hostname!=='www.toastique.com'){
msg+=' \u2014 this reCAPTCHA key only accepts tokens from domains on its allow-list. '+location.hostname+' is not on it. Either add this domain in the reCAPTCHA admin console for the key, or test on toastique.com.';
}
throw new Error(msg);
}
i=total;render();
const url=j.redirect_url||'https://toastique.com/pages/mofu-thank-you';
document.getElementById('doneBody').textContent='Taking you to the next step.';
setTimeout(function(){window.top.location.href=url},900);
}catch(err){
next.disabled=false;next.textContent='Submit';
qError.textContent=String(err.message||err);
qError.hidden=false;
}
}


let lastFocus=null;

function render(){
steps.forEach((s,n)=>s.classList.toggle('active',n===i));
const shown=Math.min(i+1,total);
bar.style.transform='scaleX('+(shown/total)+')';
count.textContent=i>=total?'Complete':'Step '+shown+' of '+total;
back.hidden=i===0||i>=total;
foot.style.display=i>=total?'none':'flex';
next.textContent=i===total-1?'Submit':'Continue';
skip.style.display=(i===2||i===total-1)?'none':'inline-flex';
modal.querySelector('.modal-body').scrollTop=0;
}
function valid(){
if(i!==2)return true;
let ok=true;
const rules={'q-first':v=>v.trim().length>=2,'q-last':v=>v.trim().length>=3,'q-email':v=>mail.test(v),'q-phone':v=>v.replace(/\D/g,'').length===10};
Object.keys(rules).forEach(function(id){
const el=document.getElementById(id);
const f=el.closest('.field');
const bad=!rules[id](el.value);
f.classList.toggle('invalid',bad);
if(bad)ok=false;
});
return ok;
}
next.addEventListener('click',function(){
if(!valid()){modal.querySelector('.field.invalid input').focus();return}
if(i===total-1){submitQuiz();return}
i=Math.min(i+1,total);render();
});
skip.addEventListener('click',function(){i=Math.min(i+1,total);render()});
back.addEventListener('click',function(){i=Math.max(i-1,0);render()});

modal.querySelectorAll('.field input').forEach(function(el){
el.addEventListener('blur',function(){
const f=el.closest('.field');
if(!f.querySelector('.err'))return;
const bad=!el.value.trim()||(el.type==='email'&&!mail.test(el.value));
f.classList.toggle('invalid',bad&&el.value.length>0);
});
});

function openQuiz(state,email){
lastFocus=document.activeElement;
i=0;
document.getElementById('q-state').value=state||'';
document.getElementById('q-email').value=email||'';
document.getElementById('k-state').textContent=state||'your state';
document.getElementById('k-email').textContent=email||'your email';
render();
modal.classList.add('open');
document.body.style.overflow='hidden';
document.getElementById('q-city').focus();
}
function closeQuiz(){
modal.classList.remove('open');
document.body.style.overflow='';
if(lastFocus)lastFocus.focus();
}
document.getElementById('qClose').addEventListener('click',closeQuiz);
modal.addEventListener('click',function(e){if(e.target===modal)closeQuiz()});
document.addEventListener('keydown',function(e){
if(e.key==='Escape'&&modal.classList.contains('open'))closeQuiz();
if(e.key!=='Tab'||!modal.classList.contains('open'))return;
const f=[...modal.querySelectorAll('button,select,input,textarea,a[href]')].filter(function(el){return el.offsetParent!==null});
if(!f.length)return;
const first=f[0],last=f[f.length-1];
if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
});

document.querySelectorAll('[data-check]').forEach(function(form){
form.addEventListener('submit',function(e){
e.preventDefault();
const st=form.querySelector('select');
const em=form.querySelector('input[type=email]');
let ok=true;
[st,em].forEach(function(el){
const f=el.closest('.field');
const bad=!el.value.trim()||(el.type==='email'&&!mail.test(el.value));
f.classList.toggle('invalid',bad);
if(bad)ok=false;
});
if(!ok){form.querySelector('.field.invalid').querySelector('input,select').focus();return}
openQuiz(st.value,em.value);
});
form.querySelectorAll('input,select').forEach(function(el){
el.addEventListener('blur',function(){
const f=el.closest('.field');
const bad=!el.value.trim()||(el.type==='email'&&!mail.test(el.value));
f.classList.toggle('invalid',bad&&el.value.length>0);
});
});
});
})();

(function(){
var els=[].slice.call(document.querySelectorAll('motion-element.tq-anim'));
if(!els.length)return;
function reveal(el){el.style.opacity='1';el.style.transform='none';el.__done=1;}
if(!('IntersectionObserver' in window)){els.forEach(reveal);return}
var timer=setInterval(function(){
var pending=0;
els.forEach(function(el){
if(el.__done)return;
if(getComputedStyle(el).opacity!=='0'){el.__done=1;return}
pending++;
var r=el.getBoundingClientRect();
if(r.top<window.innerHeight&&r.bottom>0){
if(!el.__seen)el.__seen=Date.now();
else if(Date.now()-el.__seen>2000)reveal(el);
}else{el.__seen=0}
});
if(!pending)clearInterval(timer);
},400);
})();

(function(){
var rail=document.getElementById('rail');
var hero=document.getElementById('check');
if(!rail||!hero)return;
if('IntersectionObserver' in window){
new IntersectionObserver(function(e){
rail.classList.toggle('up',!e[0].isIntersecting);
},{threshold:0}).observe(hero);
}else{rail.classList.add('up')}
var scope=document.querySelector('.tq-lp')||document;
var darkBands=[].slice.call(scope.querySelectorAll('.closer,footer.site'));
if(darkBands.length){
var raf=0;
var sync=function(){
raf=0;
var r=rail.getBoundingClientRect();
rail.classList.toggle('over-dark',darkBands.some(function(n){var b=n.getBoundingClientRect();return r.top<b.bottom&&r.bottom>b.top}));
};
var queue=function(){if(!raf)raf=requestAnimationFrame(sync)};
window.addEventListener('scroll',queue,{passive:true});
window.addEventListener('resize',queue);
sync();
}
})();
